module.exports = __webpack_public_path__ + "static/media/Negotiation.d591cd0b.png";